<template>
    <tr class="clickable-row">
        <td><a href="" @click.prevent.stop>{{getDataString(payoutTransaction.created * 1000)}}</a></td>
        <td><a href="" @click.prevent.stop>{{payoutTransaction.order.client.full_name}}</a></td>
        <td><a href="" @click.prevent.stop>
               <span v-for="item in payoutTransaction.order.items" v-bind:key="item.id">
                    {{item.title}}
                    <br>
                </span>
        </a></td>
        <td><a href="" @click.prevent.stop>{{getCurrencySymbolFromString(payoutTransaction.currency)}}{{(payoutTransaction.amount_gross/100).toFixed(2)}}</a></td>
        <td><a href="" @click.prevent.stop>{{getCurrencySymbolFromString(payoutTransaction.currency)}}{{((payoutTransaction.amount_gross/ 100).toFixed(2) - (payoutTransaction.amount / 100)).toFixed(2)}}</a></td>
        <td><a href="" @click.prevent.stop>{{getCurrencySymbolFromString(payoutTransaction.currency)}}{{(payoutTransaction.amount / 100).toFixed(2)}}</a></td>
        <td><a href="" @click.prevent.stop>{{payoutTransaction.order.fingerprint}}</a></td>
    </tr>
</template>

<script>
import {Utils} from "../../common/utils";

export default {
    name: "PayoutRow",
    props: {
        payoutTransaction: {
            type: Object,
            require: true
        }
    },
    methods: {
        getDataString(date) {
            return Utils.getDateStringFromISO(date)
        },
        getCurrencySymbolFromString(currency) {
            return Utils.getCurrencySymbolFromString(currency)
        }
    }
};
</script>
